module.exports = __webpack_public_path__ + "static/media/free.a63c52aa.svg";